"use client";

import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";
import { IMG } from "@/lib/diwline-data";
import { Crown, Sparkles, Music4 } from "lucide-react";

const NOTES = [
  { icone: Crown, titre: "Communion", texte: "Les familles royales et les délégations d'État unies sous les lambris dorés." },
  { icone: Sparkles, titre: "Distinction", texte: "Boubous d'apparat, bijoux d'or et huiles prestige offertes en cadeaux de cour." },
  { icone: Music4, titre: "Grandeur", texte: "Sabar, xalam et chants des griots pour célébrer la prospérité du royaume." },
];

export function FeteRoyale() {
  return (
    <section id="fete-royale" className="relative bg-royal-brown py-24 md:py-32" aria-label="Moments de Fête Royale">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          numero="X"
          titre="Moments de Fête Royale"
          intro="Les fastes de la Maison DiwLine célèbrent l'union de la noblesse sénégalaise et de l'élégance d'apparat. Chaque tableau capture l'esprit de communion, de distinction et de grandeur qui anime nos célébrations d'État."
        />

        <Reveal>
          <div className="gold-frame group relative overflow-hidden">
            <img
              src={`${IMG}/fete-royale.jpg`}
              alt="Célébration royale de la Maison DiwLine — noblesse sénégalaise en boubous d'or"
              loading="lazy"
              className="aspect-[16/8] w-full object-cover transition-transform duration-[2.2s] group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-royal via-transparent to-transparent" />
            <p className="absolute bottom-6 left-0 right-0 text-center font-elegant text-base md:text-xl italic text-cream/90 px-6">
              « Chaque tableau capture l&apos;esprit de communion, de distinction et de grandeur. »
            </p>
          </div>
        </Reveal>

        <div className="mt-10 grid gap-5 sm:grid-cols-3">
          {NOTES.map((n, i) => (
            <Reveal key={n.titre} delay={i * 0.1}>
              <div className="flex h-full items-start gap-4 rounded-sm border border-gold/15 bg-royal/70 p-5 transition-colors hover:border-gold/45">
                <n.icone className="mt-0.5 h-6 w-6 shrink-0 text-gold" aria-hidden />
                <div>
                  <h3 className="font-display text-lg font-semibold text-gold-light">{n.titre}</h3>
                  <p className="mt-1.5 text-[13px] leading-relaxed text-cream/70">{n.texte}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
